import request from '@core/request'

/**
 * 获取周报详情
 * @param {string|number} reportId 报告ID
 */
export function getWeeklyReportDetail(reportId) {
  return request({
    url: '/api/geo/weeklyReportDetail',
    method: 'post',
    data: { reportId },
  })
}

/**
 * 周报关键词详情(咨询详情弹窗数据源)
 * @param {object} params { reportId, keyword, model, id }
 *   - reportId 与 id 为 0 或未传时省略,交由后端默认值
 */
export function weeklyKeywordDetail(params = {}) {
  const data = { model: '', id: 0, ...params }
  if (!data.reportId) delete data.reportId
  if (!data.id) delete data.id
  return request({
    url: '/dataCenter/weeklyKeywordDetail',
    method: 'post',
    data,
  })
}
